// Auto-generated by scripts/generate_daily_seo_content.js
// Do not edit this file manually.

const dailySeoContent = {
  "updatedAt": "2026-10-22",
  "topic": "德州扑克新手规则 / 德州扑克入门教程 / 德州扑克平台怎么选",
  "metaKeywords": "德州扑克新手规则, 德州扑克入门教程, 德州扑克平台怎么选, 德州扑克平台下载, 德州扑克平台客服, 德扑平台安装教程, 德扑下载入口, 德扑下载官网, 德扑下载最新版, 俱乐部邀请码怎么获取",
  "focusKeywords": [
    {
      "keyword": "德州扑克新手规则",
      "path": "/guide",
      "anchorText": "德州扑克新手规则"
    },
    {
      "keyword": "德州扑克入门教程",
      "path": "/guide",
      "anchorText": "德州扑克入门教程详解"
    },
    {
      "keyword": "德州扑克平台怎么选",
      "path": "/guide",
      "anchorText": "德州扑克平台怎么选教程"
    },
    {
      "keyword": "德州扑克平台下载",
      "path": "/download",
      "anchorText": "德州扑克平台下载"
    },
    {
      "keyword": "德州扑克平台客服",
      "path": "/contact",
      "anchorText": "德州扑克平台客服通道"
    },
    {
      "keyword": "德扑平台安装教程",
      "path": "/install-guide",
      "anchorText": "德扑平台安装教程攻略"
    },
    {
      "keyword": "德扑下载入口",
      "path": "/download",
      "anchorText": "德扑下载入口"
    },
    {
      "keyword": "德扑下载官网",
      "path": "/download",
      "anchorText": "德扑下载官网入口"
    },
    {
      "keyword": "德扑下载最新版",
      "path": "/download",
      "anchorText": "德扑下载最新版指南"
    },
    {
      "keyword": "俱乐部邀请码怎么获取",
      "path": "/clubs",
      "anchorText": "俱乐部邀请码怎么获取"
    }
  ],
  "faqEntries": [
    {
      "name": "德州扑克新手规则怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "德州扑克核心流程：盲注→翻牌前→翻牌圈→转牌圈→河牌圈，每轮可选择弃牌/过牌/跟注/加注，最终比牌型大小决定胜负。"
      },
      "linkPath": "/guide"
    },
    {
      "name": "德州扑克入门教程怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "德州扑克核心流程：盲注→翻牌前→翻牌圈→转牌圈→河牌圈，每轮可选择弃牌/过牌/跟注/加注，最终比牌型大小决定胜负。"
      },
      "linkPath": "/guide"
    },
    {
      "name": "德州扑克平台怎么选怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "建议通过本站专题页查看最新图文步骤，再结合自身设备和版本操作，遇到问题可通过客服渠道提交截图快速处理。"
      },
      "linkPath": "/guide"
    },
    {
      "name": "德州扑克平台下载怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "从官方渠道下载最新安装包，安卓允许未知来源后直接覆盖安装；iOS需在设置中信任企业证书，全程保持Wi-Fi连接。"
      },
      "linkPath": "/download"
    }
  ]
};

export default dailySeoContent;
